import React, { useState, useEffect } from "react";
import { db } from "../firebase"; // Your Firebase config
import { ref, get, getDatabase } from "firebase/database";
import {
  FaCopy,
  FaShareAlt,
  FaCheckCircle,
  FaLink,
  FaClipboardList,
  FaList,
  FaChalkboardTeacher,
  FaUsers,
} from "react-icons/fa";

const TestPageForm = () => {
  const [testDetails, setTestDetails] = useState({
    class: "",
    division: "",
    subject: "",
    testName: "",
  });
  const [testNames, setTestNames] = useState([]); // Store all test names
  const [subjects, setSubjects] = useState([]);

  const [questions, setQuestions] = useState([]);
  const [userAnswers, setUserAnswers] = useState({});
  const [isFetched, setIsFetched] = useState(false);
  const [testLink, setTestLink] = useState("");
  const [testsList, setTestsList] = useState([]); // New state for storing all tests
  const [selectedTest, setSelectedTest] = useState(null); // New state for selected test
  const [showPopup, setShowPopup] = useState(false); // New state for popup visibility
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedDivision, setSelectedDivision] = useState(" "); 

   const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [classes, setClasses] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [classOptions, setClassOptions] = useState([]);
  const [divisionOptions, setDivisionOptions] = useState([]);

   useEffect(() => {
        if (alertMessage) {
          setShowAlert(true);
          const timeoutId = setTimeout(() => {
            setShowAlert(false);
            setAlertMessage(""); 
          }, 3000);
          return () => clearTimeout(timeoutId);
        }
      }, [alertMessage]);
    
      useEffect(() => {
          const storedLanguage = localStorage.getItem('language') || 'English';
          setLanguage(storedLanguage);
        }, []);

      const sortClasses = (classes, language) => {
        const classOrder = {
          "Class I": 1,
          "Class II": 2,
          "Class III": 3,
          "Class IV": 4,
          "Class V": 5,
          "Class VI": 6,
          "Class VII": 7,
          "Class VIII": 8,
          "Class IX": 9,
          "Class X": 10,
          "Class XI": 11,
          "Class XII": 12,
          "इयत्ता पहिली": 1,
          "इयत्ता दुसरी": 2,
          "इयत्ता तिसरी": 3,
          "इयत्ता चौथी": 4,
          "इयत्ता पाचवी": 5,
          "इयत्ता सहावी": 6,
          "इयत्ता सातवी": 7,
          "इयत्ता आठवी": 8,
          "इयत्ता नववी": 9,
          "इयत्ता दहावी": 10,
          "इयत्ता अकरावी": 11,
          "इयत्ता बारावी": 12,
        };
      
        return classes.sort((a, b) => classOrder[a] - classOrder[b]);
      };
      
    
  const handleDivisionChange = (e) => {
    setSelectedDivision(e.target.value);
  };


     const fetchClassAndDivisionData = () => {
        const storedDivClasses = localStorage.getItem("classDiv");
        if (storedDivClasses) {
          const data = JSON.parse(storedDivClasses);
          const classList = [];
          const divisionList = {};
      
          for (const [className, divisions] of Object.entries(data)) {
            classList.push(className);
            divisionList[className] = Object.keys(divisions).filter(div => divisions[div]);
          }
      
          setClassOptions(classList);
          setDivisionOptions(divisionList);
        }
      };
      useEffect(() => {
        fetchClassAndDivisionData();
      }, []);

      const handleClassChange = (event) => {
        const selected = event.target.value;
        setSelectedClass(selected);
      };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTestDetails((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Fetch subjects when class and division are entered
  useEffect(() => {
    if (selectedClass && selectedDivision) {
      fetchSubjects();
    }
  }, [selectedClass, selectedDivision]);

  // Fetch test names when subject is selected
  useEffect(() => {
    if (selectedClass && selectedDivision && testDetails.subject) {
      fetchTestNames();
    }
  }, [selectedClass, selectedDivision, testDetails.subject]);

  const fetchSubjects = async () => {
    const db = getDatabase();
    const path = `schoolRegister/${udiseNumber}/Exam/`;
    const dbRef = ref(db, path);
  
    try {
      const snapshot = await get(dbRef);
      if (snapshot.exists()) {
        const data = snapshot.val();
        const filteredSubjects = new Set();
  
        // Extract subjects for selected class and division
        Object.keys(data).forEach((key) => {
          const [studentClass, studentDivision, subject] = key.split("&&");
  
          if (
            studentClass === selectedClass && // Use selectedClass
            studentDivision === selectedDivision // Use selectedDivision
          ) {
            filteredSubjects.add(subject);
          }
        });
  
        setSubjects([...filteredSubjects]); // Update subjects dropdown
        setTestDetails((prevDetails) => ({
          ...prevDetails,
          subject: [...filteredSubjects][0] || "", // Default to first subject
        }));
      } else {
        setSubjects([]);
        setTestDetails((prevDetails) => ({
          ...prevDetails,
          subject: "",
        }));
      }
    } catch (error) {
      console.error("Error fetching subjects:", error);
    }
  };

  const fetchTestNames = async () => {
    const db = getDatabase();
    const path = `schoolRegister/${udiseNumber}/Exam/${selectedClass}&&${selectedDivision}&&${testDetails.subject}/tests`;
    const dbRef = ref(db, path);
  
    try {
      const snapshot = await get(dbRef);
      if (snapshot.exists()) {
        const tests = snapshot.val();
        const testNameList = Object.keys(tests);
  
        setTestNames(testNameList); // Update dropdown options
        setTestDetails((prevDetails) => ({
          ...prevDetails,
          testName: testNameList.length > 0 ? testNameList[0] : "", // Default to first test
        }));
      } else {
        setTestNames([]);
        setTestDetails((prevDetails) => ({
          ...prevDetails,
          testName: "",
        }));
      }
    } catch (error) {
      console.error("Error fetching test names:", error);
    }
  };

  const handleOptionChange = (questionIndex, option) => {
    setUserAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionIndex]: option,
    }));
  };

  const handleFetchQuestions = async () => {
    const path = `schoolRegister/${udiseNumber}/Exam/${selectedClass}&&${selectedDivision}&&${testDetails.subject}/tests/${testDetails.testName}`;

    try {
      const testRef = ref(db, path);
      const snapshot = await get(testRef);

      if (snapshot.exists()) {
        const data = snapshot.val();
        setQuestions(data.questions || []);
        setIsFetched(true);
        setTestsList("")
        const generatedLink = `${window.location.origin}/test/${udiseNumber}/${selectedClass}/${selectedDivision}/${testDetails.subject}/${testDetails.testName}`;
        setTestLink(generatedLink);

      } else {
        alert("No questions found for the provided details.");
        setQuestions([]);
        setIsFetched(false);
        setTestLink("");

      }
    } catch (error) {
      console.error("Error fetching questions:", error);
      alert("Failed to fetch questions.");
    }
  };

  const handleFetchAllTests = async () => {
    const path = `schoolRegister/${udiseNumber}/Exam/${selectedClass}&&${selectedDivision}&&${testDetails.subject}/tests`;

    try {
      const testsRef = ref(db, path);
      const snapshot = await get(testsRef);

      if (snapshot.exists()) {
        const data = snapshot.val();
        const tests = Object.keys(data).map((key) => ({
          id: key,
          ...data[key],
        }));
        setTestsList(tests);
        setIsFetched(false);
      } else {
        alert("No tests found for the provided details.");
        setTestsList([]);
      }
    } catch (error) {
      console.error("Error fetching tests:", error);
      alert("Failed to fetch tests.");
    }
  };

  const handleShowTest = (test) => {
    setSelectedTest(test);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setSelectedTest(null);
  };

  const handleShareTestLink = () => {
    if (!testLink) {
      alert("No test link available to share.");
      return;
    }

    const encodedLink = encodeURIComponent(testLink);
    const shareOptions = `
      <div id="share-container" style="
        position: fixed;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        padding: 20px;
        background-color: #f9f9f9;
        border: 1px solid #ddd;
        border-radius: 0 8px 8px 0;
        box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);
        z-index: 1000;
      ">
        <button id="close-share-container" style="
          position: absolute;
          top: 10px;
          right: 10px;
          background: none;
          border: none;
          font-size: 16px;
          cursor: pointer;
          font-weight: bold;
        ">&times;</button>
        <p style="font-weight: bold; font-size: 16px; margin-bottom: 10px;">Share this link:</p>
        <a href="https://wa.me/?text=${encodedLink}" target="_blank" style="margin: 10px; display: block; text-decoration: none;">
          <img src="https://img.icons8.com/fluency/48/000000/whatsapp.png" alt="WhatsApp" title="Share on WhatsApp" />
        </a>
        <a href="mailto:?subject=Test Link&body=Check out this test: ${encodedLink}" target="_blank" style="margin: 10px; display: block; text-decoration: none;">
          <img src="https://img.icons8.com/fluency/48/000000/email-open.png" alt="Email" title="Share via Email" />
        </a>
        <a href="https://www.facebook.com/sharer/sharer.php?u=${encodedLink}" target="_blank" style="margin: 10px; display: block; text-decoration: none;">
          <img src="https://img.icons8.com/fluency/48/000000/facebook-new.png" alt="Facebook" title="Share on Facebook" />
        </a>
        <a href="https://twitter.com/intent/tweet?url=${encodedLink}&text=Check out this test!" target="_blank" style="margin: 10px; display: block; text-decoration: none;">
          <img src="https://img.icons8.com/fluency/48/000000/twitter.png" alt="Twitter" title="Share on Twitter" />
        </a>
        <a href="https://t.me/share/url?url=${encodedLink}&text=Check out this test!" target="_blank" style="margin: 10px; display: block; text-decoration: none;">
          <img src="https://img.icons8.com/fluency/48/000000/telegram-app.png" alt="Telegram" title="Share on Telegram" />
        </a>
      </div>
    `;

    // Remove any existing share container
    const existingShareDiv = document.getElementById("share-container");
    if (existingShareDiv) {
      existingShareDiv.remove();
    }

    // Append new share container
    const shareDiv = document.createElement("div");
    shareDiv.innerHTML = shareOptions;
    document.body.appendChild(shareDiv);

    // Add close functionality
    const closeButton = document.getElementById("close-share-container");
    closeButton.addEventListener("click", () => {
      shareDiv.remove();
    });
  };

 

  return (
    <div className="main-content-of-page">
    <div>
      <h2
        style={{
          textAlign: "center",
          backgroundColor: "gray",
          color: "white",
          padding: "5px",
          borderRadius: "10px",
          marginBottom: "20px",
        }}
      >
        {language === "English" ? "View Test" : "चाचणी पहा"}
      </h2>

      <div
        style={{
          height: "auto",
          backgroundColor: "#f0f0f0", padding:'30px'
        }}
      >
        <form
          style={{
            background: "#ffffff",
            padding: "30px",
            borderRadius: "12px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            width: "450px",
            maxWidth: "90%",
            margin:'auto'
          }}
        >
          {/* Class Field */}
          <label style={{ display: "block", marginBottom: "20px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "5px",
              }}
            >
              <FaChalkboardTeacher
                style={{ marginRight: "10px", color: "#555" }}
              />
              <span> {language === "English" ? "Class" : "वर्ग"}</span>
            </div>
             <select
      id="currentClass"
      value={selectedClass}
      onChange={handleClassChange}
    >
       <option value="">{language === "English" ? " Select Class " : "वर्ग निवडा "}</option>
              {classOptions.map((cls, index) => (
                <option key={index} value={cls}>{cls}</option>
              ))}
    </select>
          </label>

          {/* Division Field */}
          <label style={{ display: "block", marginBottom: "20px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "5px",
              }}
            >
              <FaUsers style={{ marginRight: "10px", color: "#555" }} />
              <span>{language === "English" ? "Division" : "तुकडी"}</span>
            </div>
            <select
  id="division"
  value={selectedDivision}
  onChange={handleDivisionChange}
>
   <option value="">{language === "English" ? " Select Division: " : "तुकडी निवडा "}</option>
              {divisionOptions[selectedClass]?.map((division, index) => (
                <option key={index} value={division}>{division}</option>
              ))}
</select>
          </label>

          <label style={{ display: "block", marginBottom: "20px" }}>
  <div style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
    <FaClipboardList style={{ marginRight: "10px", color: "#555" }} />
    <span>{language === "English" ? "Subject" : "विषय"}</span>
  </div>
  <select
    name="subject"
    value={testDetails.subject}
    onChange={handleInputChange}
    required
    style={{
      padding: "10px",
      width: "100%",
      borderRadius: "8px",
      border: "1px solid #ddd",
      fontSize: "14px",
    }}
  >
    <option value="">{language === "English" ? "Select Subject" : "विषय निवडा"}</option>
    {subjects.map((subject, index) => (
      <option key={index} value={subject}>
        {subject}
      </option>
    ))}
  </select>
  </label>
          {/* Test Name Dropdown */}
          <label style={{ display: "block", marginBottom: "20px" }}>
  <div style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
    <FaClipboardList style={{ marginRight: "10px", color: "#555" }} />
    <span>{language === "English" ? "Test Name" : "चाचणी नाव"}</span>
  </div>
  <select
    name="testName"
    value={testDetails.testName}
    onChange={handleInputChange}
    required
    style={{
      padding: "10px",
      width: "100%",
      borderRadius: "8px",
      border: "1px solid #ddd",
      fontSize: "14px",
    }}
  >
    {testNames.length > 0 ? (
      testNames.map((test) => (
        <option key={test} value={test}>
          {test}
        </option>
      ))
    ) : (
      <option value="">{language === "English" ? "No tests available" : "कोणत्याही चाचण्या उपलब्ध नाहीत"}</option>
    )}
  </select>
</label>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
            }}
          >
            <button
              type="button"
              onClick={handleFetchQuestions}
              style={{
                backgroundColor: "#008CBA",
                color: "white",
                padding: "10px 18px",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                flex: 1,
                marginRight: "10px",
                transition: "background-color 0.3s ease",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#007B9E")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#008CBA")}
            >
              <FaLink /> {language === "English" ? "View Test" : "चाचणी पहा"}
            </button>
            <button
              type="button"
              onClick={handleFetchAllTests}
              style={{
                backgroundColor: "#4CAF50",
                color: "white",
                padding: "10px 18px",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                flex: 1,
                transition: "background-color 0.3s ease",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#45a049")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#4CAF50")}
            >
              <FaList /> {language === "English" ? "Show All Tests" : "सर्व चाचण्या दाखवा"}
            </button>
          </div>
        </form>
      </div>

      {testsList.length > 0 && (
        <div
          style={{
            marginTop: "0px",
            background: "#f9f9f9",
            padding: "10px",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <h4
            style={{
              textAlign: "center",
              backgroundColor: "gray",
              color: "white",
              padding: "5px",
              borderRadius: "8px",
              margin:'auto',
              marginBottom: "18px",
              width:"300px"
            }}
          >
            {language === "English" ? "All Tests" : "सर्व चाचणी"}
          </h4>
          <table
            style={{
              width: "80%",
              borderCollapse: "collapse",
              margin:'auto',
              marginBottom: "20px"
            }}
          >
            <thead>
              <tr>
                <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight:'bold', textAlign:'center' }}>
                  {language === "English" ? " Test Name " : "चाचणी नाव"}
                </th>
                <th style={{ border: "1px solid #ddd", padding: "8px" , fontWeight:'bold', textAlign:'center'}}>
                  {language === "English" ? "  Action " : "कृती"}
                </th>
              </tr>
            </thead>
            <tbody>
              {testsList.map((test) => (
                <tr key={test.id}>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    {test.id}
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    <button
                      onClick={() => handleShowTest(test)}
                      style={{
                        backgroundColor: "#008CBA",
                        color: "white",
                        padding: "5px 10px",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                     {language === "English" ? " Show Test " : "चाचणी दाखवा"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showPopup && selectedTest && (
        <>
          {/* Blurred background with light black color */}
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent black background
              zIndex: 999,
            }}
          />

          {/* Popup box */}
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              background: "#fff",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
              zIndex: 1000,
              width: "80%",
              maxWidth: "800px",
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
                 {language === "English" ? " Test:- " : "चाचणी "}{selectedTest.id}
            </h2>
            <ol style={{ listStyleType: "none", padding: 0 }}>
              {selectedTest.questions.map((question, index) => (
                <li
                  key={index}
                  style={{
                    marginBottom: "20px",
                    padding: "15px",
                    background: "#f9f9f9",
                    borderRadius: "8px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  <p style={{ fontWeight: "bold", marginBottom: "10px", fontSize: "14px" }}>
                    {question.question}{" "}
                    <span style={{ color: "green", marginLeft: "10px" }}>
                      ( {language === "English" ? " Marks:- " : "गुण "} {question.marks || 1})
                    </span>
                  </p>
                  {question.options.map((option, optIndex) => (
                    <div key={optIndex} style={{ marginBottom: "10px" }}>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <input style={{width:'auto'}}
                          type="radio"
                          name={`question-${index}`}
                          value={option}
                          onChange={() => handleOptionChange(index, option)}
                        />
                        {option}
                      </label>
                    </div>
                  ))}
                </li>
              ))}
            </ol>
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <button
                onClick={() => {
                  const printWindow = window.open("", "_blank");
                  printWindow.document.write(`
              <html>
                <head>
                  <title>Print Test</title>
                  <style>
                    @media print {
                      @page {
                        size: A4 portrait;
                        margin: 0;
                      }
                      body {
                        font-family: Arial, sans-serif;
                        margin: 0;
                        padding: 20px;
                        background: #f9f9f9;
                      }
                      .test-header {
                        text-align: center;
                        margin-bottom: 20px;
                        padding: 10px;
                        background: #fff;
                        border-radius: 8px;
                        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                      }
                      .test-header h2 {
                        margin: 0;
                        font-size: 24px;
                        color: #333;
                      }
                      .test-header p {
                        margin: 5px 0;
                        font-size: 16px;
                        color: #666;
                        display: inline-block;
                        margin-right: 20px;
                      }
                      .question {
                        margin-bottom: 20px;
                        padding: 15px;
                        background: #fff;
                        border-radius: 8px;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                        width: 100%;
                      }
                      .question p {
                        font-weight: bold;
                        margin: 0 0 10px 0;
                        font-size: 18px;
                        color: #333;
                      }
                      .question ul {
                        list-style-type: none;
                        padding: 0;
                        margin: 0;
                      }
                      .question li {
                        margin-bottom: 10px;
                        font-size: 16px;
                        color: #555;
                      }
                      .question label {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                      }
                    }
                  </style>
                </head>
                <body>
                  <div class="test-header">
                    <h2>Test:- ${selectedTest.id}</h2>
                    <p>Class: ${selectedClass}</p>
                    <p>Division: ${selectedDivision}</p>
                    <p>Subject: ${testDetails.subject}</p>
                  </div>
                  <ol>
                    ${selectedTest.questions
                      .map(
                        (question, index) => `
                          <li class="question">
                            <p>${
                              question.question
                            } <span style="color: green; margin-left: 10px;">(Marks: ${
                          question.marks || 1
                        })</span></p>
                            <ul>
                              ${question.options
                                .map(
                                  (option, optIndex) => `
                                    <li>
                                      <label>
                                        <input type="radio" name="question-${index}" value="${option}" />
                                        ${option}
                                      </label>
                                    </li>
                                  `
                                )
                                .join("")}
                            </ul>
                          </li>
                        `
                      )
                      .join("")}
                  </ol>
                </body>
              </html>
            `);
                  printWindow.document.close();
                  printWindow.print();
                  printWindow.close();
                }}
                style={{
                  backgroundColor: "#008CBA",
                  color: "white",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  marginRight: "10px",
                  fontSize: "16px",
                }}
              >
                Print
              </button>
              <button
                onClick={handleClosePopup}
                style={{
                  backgroundColor: "#f44336",
                  color: "white",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "16px",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </>
      )}

      {isFetched && questions.length > 0 && (
        <div
          style={{
            marginTop: "0px",
            background: "#f9f9f9",
            padding: "10px",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <h4
            style={{
              textAlign: "center",
              backgroundColor: "gray",
              color: "white",
              padding: "5px",
              borderRadius: "8px",
              margin:'auto',
              marginBottom: "18px",
              width:"300px"
            }}
          >
            {language === "English" ? "  Shareable Test " : "चाचणी पाठवा "}
          </h4>
          <div style={{ textAlign: "center", margin: "20px 0", display:'flex', justifyContent:'space-between' }}>
          
          <h5 className="text-center"  style={{borderBottom:'2px solid gray'}}>{testDetails.testName}</h5>
           <div>
            <button
              onClick={() => {
                navigator.clipboard.writeText(testLink);
                alert("Link copied to clipboard!");
              }}
              style={{
                backgroundColor: "#008CBA",
                color: "white",
                padding: "5px 15px",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                marginTop: "0px",
                marginRight: "10px",
                display: "inline-flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <FaCopy />  {language === "English" ? "  Copy Link " : "लिंक कॉपी करा "}
            </button>
            <button
              onClick={handleShareTestLink}
              style={{
                backgroundColor: "#4CAF50",
                color: "white",
                padding: "5px 15px",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                marginTop: "0px",
                display: "inline-flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <FaShareAlt /> {language === "English" ? "Share Link " : "लिंक शेअर करा "}
            </button>
          </div>
          </div>

          <ol style={{ listStyleType: "none", padding: 0 }}>
  {questions.map((question, index) => (
    <li
      key={index}
      style={{
        marginBottom: "20px",
        padding: "15px",
        background: "#fff",
        borderRadius: "8px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        display: "flex", // Use flexbox for layout
        flexDirection: "column", // Stack items vertically
      }}
    >
      <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
        <span style={{ fontWeight: "bold", marginRight: "10px" }}>
          {index + 1}. 
        </span>
        <p style={{ margin: 0 , fontWeight:'bold', fontSize:'14px'}}>{question.question}</p>
      </div>
      <div style={{ margin: "0" }}> 
        {question.options.map((option, optIndex) => (
          <div key={optIndex} style={{ marginBottom: "10px" }}>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px", fontSize:'14px'
              }}
            >
              <input style={{width:'auto'}}
                type="radio"
                name={`question-${index}`}
                value={option}
                onChange={() => handleOptionChange(index, option)}
              />
              {option}
            </label>
          </div>
        ))}
      </div>
    </li>
  ))}
</ol>
     
        </div>
      )}
    </div>
    </div>
  );
};

export default TestPageForm;
